import React, { Component } from 'react';
import * as S from './styles';

class Stepper extends Component {
  render() {
    const {
      props: { position, mode },
    } = this;

    return (
      <S.StepperWrapper>
        <S.StepperItemFirst
          color={position >= 1 ? '#00967D' : 'tranparent'}
          opacity={position === 1 && mode === 'half' ? '30%' : '100%'}
        />
        <S.StepperItem
          color={position >= 2 ? '#00967D' : 'tranparent'}
          opacity={position === 2 && mode === 'half' ? '30%' : '100%'}
        />
        <S.StepperItemLast
          color={position >= 3 ? '#00967D' : 'tranparent'}
          opacity={position === 3 && mode === 'half' ? '30%' : '100%'}
        />
      </S.StepperWrapper>
    );
  }
}

export default Stepper;
